/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { AllasStandaloneArticlePaywall as ResolvedStandaloneArticlePaywall } from 'sites/allas/components/standalone/ArticlePaywall';

export const ArticlePaywall: typeof ResolvedStandaloneArticlePaywall = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneArticlePaywall {...props} />
    );
});

export type ArticlePaywallProps = PropsFromComponent<typeof ArticlePaywall>;

/** @deprecated Use slot architecture instead */
export const ArticlePaywallWith = (extras: DynamicStandaloneExtras): typeof ArticlePaywall => {
    return function ArticlePaywall(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticlePaywall');
        return <ResolvedStandaloneArticlePaywall {...mergeProps({ options: { theme } }, props)} />;
    }
}